module.exports = __webpack_public_path__ + "static/img/iconfont.cdf29ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.svg?t=1545138724935
// module id = wTVf
// module chunks = 104